<template>
  <div class="notfound">
      <div class="m-main-cont">
          <p class="p1">真不巧，网页走丢了。</p>
          <p class="p2">刷新网页或者返回首页吧。</p>
          <a href="/">返回首页</a>
      </div>
  </div>
</template>
<style scoped lang="scss">
.notfound{
	width: 800px;
	margin: 100px auto;
}
.m-main-cont{
	
	height: 300px;
	background: url(../assets/images/notfound@1x.jpg) no-repeat;
	padding-left: 420px;
	padding-top: 100px;
}
.p1{
	color: #3E5AC2;
    font-size: 30px;
    line-height: 42px;
    margin-bottom: 6px;
	font-family: 'PingFangSC-Semibold';
}
.p2{
	font-size: 20px;
	line-height: 28px;
	color: #757575;
	margin-bottom: 35px;
}
a{
	font-size: 20px;
	display: block;
	width: 120px;
	height: 50px;
	line-height: 50px;
	color: #fff;
	background-color: #3E5AC2;
	text-align: center;
}
 </style>
<script>
export default {
  name:'notfound'
}
</script>